import { useQuery } from '@tanstack/react-query';
import { getExerciseSessionDates } from '../../../api/diary-service';

const useSessionDates = (from, to) => {
    return useQuery({
        queryKey: ['exerciseSessionDates', from, to],
        queryFn: () => getExerciseSessionDates(from, to),
        staleTime: 1000 * 60 * 5,
        refetchOnWindowFocus: false,
        retry: 1
    });
};

export default useSessionDates;
